import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Icon } from '@knockrentals/knock-shared-web-v2';

export const REMOVE_OPTION_CHIP_LABEL = 'remove option';

const SelectedOptionChip = ({ label, tagProps }) => (
  <Chip
    deleteIcon={
      <Icon
        aria-label={REMOVE_OPTION_CHIP_LABEL}
        color="slate.500"
        name="component-cancel-filled"
        size={20}
      />
    }
    label={label}
    {...tagProps}
  />
);

SelectedOptionChip.propTypes = {
  label: PropTypes.string,
  tagProps: PropTypes.object,
};

export default SelectedOptionChip;
